import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useStore } from '../../../hook-store/store';

import { marks } from '../../../utils/marks';
import './FileControl.css';

// let vttTestEl;

function VttTest(props) {

  const { transcribeVttFile } = props;

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    // console.log('store-App.tsx', store);
    const { mlIsBusy } = store.uiStore;
    const { 
        mlSpeechCurrentAudioData,
        mlSpeechText,
        mlSpeechSrtText,
    } = store.mlSpeechStore;

    // console.log(mlSpeechCurrentAudioData)
    const [vttTestEl, setVttTestEl] = useState();
    const [vttTrackText, setVttTrackText] = useState('');

    useEffect(() => {
        if (vttTestEl) {
            console.log(vttTestEl)
            const audioPlayer = document.getElementById('audioPlayer');
            // const captionArea = document.getElementById('captionDisplayArea');
            const trackElement = document.getElementById('vttTrack');
            
            if (audioPlayer) {
                console.log(audioPlayer.textTracks)
                const track = audioPlayer.textTracks[0];
                track.mode = 'showing';
            }
            console.log(trackElement)
            if (trackElement) {
                const trackTrack = trackElement.track;
                trackTrack.mode = "showing";

                console.log(trackTrack)

                trackElement.addEventListener("cuechange", (event) => { 
                    console.log(event);
                    const activeCues = event.target.track.activeCues;
                    console.log(activeCues);
                    if (activeCues.length > 0) {
                        // console.log(activeCues[0])
                        //  console.log(activeCues[0].text)
                        setVttTrackText(activeCues[0].text);
                    }
                });
            }
        }
    },[vttTestEl]);

    useEffect(() => {
        setVttTestEl(null);
        setVttTrackText('');
    },[mlSpeechCurrentAudioData]);

    useMemo(() => {
        // console.log('in-useMemo')
        if (mlSpeechCurrentAudioData && transcribeVttFile) {  
            // console.log(mlSpeechCurrentAudioData)
            if (mlSpeechCurrentAudioData.mimeType.split('/')[0] === 'audio') {
                setVttTestEl(
                    <audio controls id="audioPlayer"
                        style={{maxWidth: "100%"}}
                    >
                        <source src={mlSpeechCurrentAudioData.url}  
                        // type="audio/mpeg"
                        />
                        <track 
                            id="vttTrack" 
                            kind="captions" 
                            src={URL.createObjectURL(transcribeVttFile)} 
                            // srclang="en" 
                            // label="English" 
                            default
                        />
                    </audio>
                );                
            } 
            if (mlSpeechCurrentAudioData.mimeType.split('/')[0] === 'video') {
                setVttTestEl(
                    <video controls 
                    style={{maxWidth: "100%"}}
                    >
                        <source 
                            src={mlSpeechCurrentAudioData.url} 
                            type={mlSpeechCurrentAudioData.mimeType}
                        />
                        <track 
                            kind="captions" 
                            src={URL.createObjectURL(transcribeVttFile)}
                            // srclang="en" 
                            // label="English" 
                            default 
                        />
                        Your browser does not support the video tag.
                    </video>
                );
            }
        }
    },[transcribeVttFile]);

 

    let vttTestBody;

    vttTestBody = (
          <div>
            <div>{vttTestEl}</div>
            <div id="captionDisplayArea"
              className="transcribeFileControlRow"
            >
                <strong>
                  {vttTrackText}
                </strong>
            </div>
          </div>
        );

  return (
        <div>
            {vttTestBody}
        </div>
    );
}

export default VttTest;
